import React from 'react';
import ReactDOM from 'react-dom/client';
import ContactForm from './contact/ContactForm';
const container = document.getElementById('contact-form');
// #
if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(React.createElement(ContactForm, null));
}
